export const useStyles = theme => ({
  pickemItem: {
    marginBottom: '15px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  pickemMainContainer: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  pickemItemHalfContainer: {
    width: '50%',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  pickemItemFullContainer: {
    width: '100%',
    flexDirection: 'column',
  },
  pickemOptions: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-between',
    },
  },
  borderButton: {
    // border: '1px solid #A0750E',
    border: '1px solid',
    backgroundColor: 'transparent',
    color: '#A0750E',
    boxShadow: 'none',
    minWidth: '200px',
    textAlign: 'center',
    fontSize: '18px',
    letterSpacing: '1.6px',
    padding: '8px 10px',
    marginRight: '15px',
    marginBottom: '15px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#A0750E',
      color: '#fff',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: '48%',
      marginRight: 'unset',
    },
  },
  mightyButton: {
    border: '1px solid #182C55',
    backgroundColor: '#182C55',
    color: 'white',
    boxShadow: 'none',
    textAlign: 'center',
    fontSize: '15px',
    padding: '8px 10px',
    marginRight: '10px',
    marginBottom: '10px',
    textTransform: 'none',
    fontFamily: '"Barlow", sans-serif',
    [theme.breakpoints.down('sm')]: {
      minWidth: '48%',
      marginRight: 'unset',
    },
  },
  mightyBorderButton: {
    border: '1px solid #182C55',
    backgroundColor: 'transparent',
    color: '#182C55',
    boxShadow: 'none',
    textAlign: 'center',
    fontSize: '15px',
    padding: '8px 10px',
    marginRight: '10px',
    marginBottom: '10px',
    textTransform: 'none',
    fontFamily: '"Barlow", sans-serif',
    [theme.breakpoints.down('sm')]: {
      minWidth: '48%',
      marginRight: 'unset',
    },
  },
  actionButton: {
    border: '1px solid',
    backgroundColor: 'transparent',
    color: '#A0750E',
    boxShadow: 'none',
    minWidth: '200px',
    textAlign: 'center',
    fontSize: '18px',
    letterSpacing: '1.6px',
    padding: '8px 10px',
    marginRight: '15px',
    marginBottom: '15px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#A0750E',
      color: '#fff',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      marginRight: 'unset',
    },
  },
  tieBreaker: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  mightyIndex: {
    width: '10%',
    float: 'left',
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: '5px',
    '& p': {
      color: '#182C55',
    }
  },
  mightyQuestion: {
    width: '90%',
    float: 'right',
    paddingLeft: '10px',
    '& h2': {
      fontFamily: '"Barlow", sans-serif',
      color: '#182C55',
    },
  },
  prevButton: {
    width: '20%',
    height: '40px',
    borderRadius: '4px',
    backgroundColor: 'white',
    cursor: 'pointer',
    margin: '10px 0px 10px 10px',
    float: 'right',
  },
  nextButton: {
    width: '20%',
    height: '40px',
    borderRadius: '4px',
    cursor: 'pointer',
    margin: '10px 0px 10px 10px',
    float: 'right',
  },
  submitView: {
    //marginLeft: '10%',
    marginTop: '10px',
    [theme.breakpoints.between('sm', 'md')]: {
      marginBottom: '4em',
    },
  },
  submittedText: {
    //color: '#ED162D',
    fontWeight: 'bold',
    fontSize: '0.8em',
    marginBottom: '20px',
  },
  tieBreakerUHG: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: '#0c2572',
      },
    },
  },
});
